import { api } from "@/api";
import type {
  ActivitiesResponse,
  Contact,
  SaveQuickTaskRequest,
  SaveQuickTaskResponse,
} from "@/types/domain";

export const fetchActivities = async (): Promise<ActivitiesResponse> => {
  const response = await api.get<ActivitiesResponse>("/task/activities");
  return response.data;
};

export const fetchContactsByCompany = async (customerId: string): Promise<Contact[]> => {
  const response = await api.get<Contact[]>("/task/contacts", {
    params: { customerId },
  });
  return response.data ?? [];
};

export const saveQuickTask = async (
  dto: SaveQuickTaskRequest
): Promise<SaveQuickTaskResponse> => {
  const response = await api.post<SaveQuickTaskResponse>("/task/quicktask", dto);
  return response.data;
};
